import "./TrendingEventCard.scss";
import { InfoCircleOutlined } from "@ant-design/icons";

type TrendingEventCardProps = {
  title: React.ReactNode;
  ticker: string;
  events: {
    title: React.ReactNode;
    subtitle: string;
  }[];
  children?: React.ReactNode;
  colorIndex?: number;
  isHotEvent?: boolean;
};

const COLOR_PALETTES = [
  { dot: "#2563eb", chipBg: "#eff6ff", chipText: "#2563eb" }, // Blue
  { dot: "#d97706", chipBg: "#fffbeb", chipText: "#d97706" }, // Orange
  { dot: "#059669", chipBg: "#ecfdf5", chipText: "#059669" }, // Green
  { dot: "#475569", chipBg: "#f1f5f9", chipText: "#475569" }, // Slate
];

const TrendingEventCard = (props: TrendingEventCardProps) => {
  const isHotEvent = props.isHotEvent;
  const palette = isHotEvent && props.colorIndex !== undefined 
    ? COLOR_PALETTES[props.colorIndex % COLOR_PALETTES.length] 
    : null;

  const handleCardClick = () => {
    const ticker = props.ticker;
    if (ticker) {
      window.localStorage.setItem("selectedTab", "0");
      window.localStorage.setItem("tickerId", ticker);
      window.location.href = `/detail`;
    }
  };

  return (
    <div 
      className={`trending-event-card ${isHotEvent ? 'hot-event-card' : ''}`}
      onClick={handleCardClick}
    >
      <div className="card-title">
        {isHotEvent && palette && (
          <div className="event-dot" style={{ backgroundColor: palette.dot }}></div>
        )}
        <div className="name">{props.title}</div>
        {!isHotEvent && <div className="ticker">{props.ticker}</div>}
      </div>
      <div className="events">
        {props.events.map((event, i) => (
          <div className="event" key={i}>
            {isHotEvent && palette ? (
              <div 
                className="event-title chip-title" 
                style={{ backgroundColor: palette.chipBg, color: palette.chipText }}
              >
                {event.title}
              </div>
            ) : (
              <div className="event-title">{event.title}</div>
            )}
            <div className="event-subtitle">{event.subtitle}</div>
          </div>
        ))}
      </div>
      {props.children && <div className="extra-content">{props.children}</div>}
    </div>
  );
};

export default TrendingEventCard;
